var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal-form",
    {
      class: _vm.$style.dialog,
      on: { cancel: _vm.$formCancelHandler, submit: _vm.$formSubmitHandler },
    },
    [
      _c(
        "div",
        { class: _vm.$style.header, attrs: { slot: "header" }, slot: "header" },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("info_outline")]),
          _c("div", [
            _c("div", { class: _vm.$style.title }, [
              _vm._v(" Exit This Page "),
            ]),
            _c("div", { class: _vm.$style.subTitle }, [
              _vm._v(" You are about to exit the invitation page "),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultBody",
          class: _vm.$style.body,
          attrs: { slot: "body" },
          slot: "body",
        },
        [
          _vm._v(
            " Once you exit this invitation page, you will only be able to access it again by clicking on the invitation link sent to your email. Click on "
          ),
          _c("b", [_vm._v("OK")]),
          _vm._v(" to exit or "),
          _c("b", [_vm._v("Go Back")]),
          _vm._v(" to stay on this page. "),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "vModalDefaultFooter",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "button",
            {
              staticClass: "rbButton",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" Ok ")]
          ),
          _c("button", { staticClass: "rbButton mainButton" }, [
            _vm._v(" Go Back "),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }